import template from './record-groups-assigned.pug';
import { plural } from 'pluralize';

export const RecordGroupsAssignedComponent = {
  template,
  bindings: {
    record: '<',
    module: '<',
  },
  controller: class RecordGroupsAssignedComponent {
    constructor(RecordGroup, $window, $state, $async, $log) {
      'ngInject';
      this.RecordGroup = RecordGroup;
      this.$window = $window;
      this.$state = $state;
      this.$log = $log;
      this.assignedGroups = [];
      this.getAssignedGroups = $async(this.getAssignedGroups.bind(this));
      this.assign = $async(this.assign.bind(this));
      this.remove = $async(this.remove.bind(this));
    }

    $onInit() {
      this.getAssignedGroups();
    }

    async getAssignedGroups() {
      try {
        const resp = await this.RecordGroup.getAssignedGroups(this.record.id, this.module);
        if (resp && resp.length) {
          this.assignedGroups = resp;
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    open(recordGroup) {
      this.$window.open(
        this.$state.href('main.'+ plural(this.module) +'.list', { groupId: recordGroup.id, page: 1 }),
        '_blank');
    }

    async assign() {
      try {
        const assignedGroups = await this.RecordGroup.assignModal(this.record.id, this.module, this.assignedGroups);
        this.assignedGroups = assignedGroups;
      } catch (e) {
        this.$log.error(e);
      }
    }

    async remove(recordGroup) {
      try {
        await this.RecordGroup.remove(recordGroup.id, this.record.id, this.module);
        this.assignedGroups = this.assignedGroups.filter(group => group.id !== recordGroup.id);
      } catch (e) {
        this.$log.error(e);
      }
    }

  }
};
